// extracted by mini-css-extract-plugin
export default {"SpringForward":"springForward_SpringForward__uHlym"};